<template>
  <div class="main-content">
    <!-- Page Header Start -->
    <PageHeader>
      <PageHeaderTitleContent>
        <TitleTextContent 
          :titleText="'Policy Corner'" 
          :subTitleText="'Policies serve as the framework governing interactions across government and between the public and private sector. Standardizing the methodology for specific interactions and transactions between government and industry provides a universal framework by which all organizations doing business with the government must operate. Effective policies inform decision-makers on critical items such as resource allocation, staffing, and business development.'"
        />
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->

    <!-- Policy Corner Grid Section Start -->
    <section class="section p-0 mt-5 mb-5 section-content">
      <div class="container-fluid px-xs-1 px-md-5 px-lg-5">
        <div class="w-100 policy-data-row policy-data-border row m-0 p-0 mb-3" v-for="policy in policyData" :key="policy.policyCode">
          <div class="policy-data-text policy-name px-3 col-12 col-md-3 col-lg-3 col-xl-3 p-0 d-flex justify-content-start justify-content-md-center  justify-content-lg-center justify-content-xl-center align-items-center text-start text-md-center text-lg-center tex-xl-center">
            {{ policy.policyName }}
          </div>
          <div class="policy-data-border col-12 col-md-9 col-lg-9 col-xl-9 p-0">
            <div class="row h-100 m-0 p-1 p-md-0 p-lg-0 p-xl-0">
              <div class="policy-data-text policy-summary px-3 py-2 py-md-0 py-lg-0 py-xl-0 col-12 col-md-9 col-lg-10 col-xl-10 p-0 d-flex flex-column justify-content-center">
                <div style="height: auto;" class="text-start limit-lines-1">
                  {{ policy.policySummary }}
                </div>
              </div>
              <div class="col-12 col-md-3 col-lg-2 col-xl-2 p-0 pb-2 pb-md-0 pb-lg-0 pb-xl-0 d-flex justify-content-center align-items-center">
                <router-link
                  :to="{
                    name: 'policy-corner-info',
                    query: {
                      policyCode: policy.policyCode,
                    },
                  }"
                >
                  <v-btn
                    rounded
                    large
                    dark
                    :color="'#424EC4'"
                  >
                    Read More
                  </v-btn>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Policy Corner Grid Section Start -->

  </div>
</template>

<script>
import axios from 'axios';
import { BPagination, BFormInput } from 'bootstrap-vue';
import PageHeader from "./library/widgets/page-header.vue";
import PageHeaderTitleContent from "./library/widgets/page-header-title-content.vue";
import TitleTextContent from './library/widgets/title-text-content.vue';
import policyCornerList from '../utils/policyCornerListData';

export default {
  name: 'policies',
  components: {
    BPagination,
    BFormInput,
    PageHeader,
    PageHeaderTitleContent,
    TitleTextContent,
  },
  props: {
    query: String,
  },
  data() {
    return {
      policyData: [],
      staticPolicyData: policyCornerList,
    };
  },
  mounted() {
    this.policyData = [ ...this.staticPolicyData ];
  },
  methods: {
    getFormattedDate(dateString) {
      const options = { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
    getPolicyData() {
      axios
        .get('/api/resources/policies')
        .then((response) => {
          this.policyData = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
<style scoped>
.inner-header-bg {
  background-image: url('~@/assets/images/headers/events.png');
  background-position: center center;
}
#blog-pagination li {
  margin: 0px;
}

.policy-data-row {
  min-height: 90px;
  border-radius: 3px;
  background-color: rgba(217, 217, 217, 0.00);
}

.policy-data-border {
  border: 1px solid rgba(0, 0, 0, 0.20);
}

.policy-name {
  font-weight: bold;
}

.policy-summary {
  font-weight: 400;
}

.policy-data-text {
  color: #000;
  font-family: Rajdhani;
  font-size: 18px;
  font-style: normal;
  line-height: 24px;
  word-wrap: break-word;
}

.cover {
  object-fit: cover;
  height: 225px;
  width: 100%;
}

.tool-icon {
  object-fit: cover;
  height: 50px;
  width: 80px;
  margin-right: 10px;
}

.image-and-tool {
  max-width: 325px;
  align-items: center;
}

.btn-more {
  width: 100px;
  height: auto;
  padding: 0.25rem 0.5rem;
}
</style>
